export const VIDEO_CAMPAIGN_SUFFIX = '-video';
export const REALTIME_CAMPAIGN_SUFFIX = '-realtime';
